export type CreatorSiteSitemapEntry = {
  /** Vanity-relative path: `/` for homepage, `/{pageSlug}` for subpages. */
  path: string;
  lastmod: string;
};

export function escapeXmlText(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

export function buildCreatorSiteSitemapXml(
  entries: Array<{ loc: string; lastmod: string }>,
): string {
  const urlNodes = entries
    .map(
      (entry) =>
        `  <url>\n    <loc>${escapeXmlText(entry.loc)}</loc>\n    <lastmod>${escapeXmlText(entry.lastmod)}</lastmod>\n  </url>`,
    )
    .join('\n');

  return `<?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n${urlNodes}\n</urlset>\n`;
}

export function formatCreatorSiteSitemapLastmod(value: Date | string): string {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return new Date().toISOString().slice(0, 10);
  }
  return date.toISOString().slice(0, 10);
}
